import { GraphQLError } from 'graphql';

const getErrorMessage = (err: any, isUserError?: boolean) => {
  if (typeof err === 'string') {
    return err;
  }
  if (err.networkError) {
    return isUserError ? 'Please contact your admin to set up the district' : 'Network Error';
  }
  if (err.graphQLErrors) {
    return err.graphQLErrors.map((gErr: GraphQLError) => gErr.message).join(', ');
  }
  return err.message;
};

export default getErrorMessage;
